import Loader from 'components/_UI/Loader'
import Text from 'components/_UI/Text'
import React, { useState, useEffect } from 'react'
import { Tag, Check } from 'react-feather'
import { Column } from 'styled/alignment/Column'
import colors from 'theme/colors'
import { useTags } from 'context/events/Tags'
import styled from 'styled-components'
import breakpoints from 'theme/breakpoints'

export default function CategoriesInfo({ tagsLoading, error, edit, setSelecteds }) {
    const { tags } = useTags();
    const MAX_TAGS = 3;

    const [selectedItems, setSelectedItems] = useState(edit?.map(item => item.id) || []);
    const [shakeId, setShakeId] = useState(null);

    useEffect(() => {
        if (edit) {
            const items = edit?.map(item => item?.id)
            setSelectedItems(items);
            setSelecteds(items);
        }
    }, [error, tagsLoading])


    const handleSelectItem = (id) => {
        setSelectedItems(prevSelectedItems => {
            let newSelectedItems;

            if (prevSelectedItems.includes(id)) {
                newSelectedItems = prevSelectedItems.filter(item => item !== id);
            } else {
                if (prevSelectedItems.length >= MAX_TAGS) {
                    setShakeId(id);
                    setTimeout(() => setShakeId(null), 500);
                    return prevSelectedItems;
                }
                newSelectedItems = [...prevSelectedItems, id];
            }

            setSelecteds(newSelectedItems);
            return newSelectedItems;
        });
    };

    const isMaxReached = selectedItems.length >= MAX_TAGS;

    return (
        <Column>
            <SectionHeader>
                <SectionIcon><Tag size={18} color={colors.occasionalPurple} /></SectionIcon>
                <HeaderContent>
                    <Text type='bold' color={colors.nightDark}>
                        Categorias
                    </Text>
                    <CounterRow>
                        <Text name='small' color={colors.night}>
                            Selecione até {MAX_TAGS} categorias para o seu evento.
                        </Text>
                        <Counter reached={isMaxReached}>
                            {selectedItems.length}/{MAX_TAGS}
                        </Counter>
                    </CounterRow>
                </HeaderContent>
            </SectionHeader>

            {tagsLoading ? <Loader /> : (
                <ChipsContainer>
                    {tags?.map(el => {
                        const isSelected = selectedItems.includes(el.id);
                        const isDisabled = isMaxReached && !isSelected;

                        return (
                            <Chip
                                key={el.id}
                                selected={isSelected}
                                disabled={isDisabled}
                                shake={shakeId === el.id}
                                onClick={() => handleSelectItem(el.id)}
                            >
                                {isSelected && <Check size={14} />}
                                <ChipLabel>{el.name}</ChipLabel>
                            </Chip>
                        );
                    })}
                </ChipsContainer>
            )}

            {error === 'min' && (
                <ErrorText>Selecione pelo menos uma categoria</ErrorText>
            )}
        </Column>
    )
}

const SectionHeader = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin-bottom: 16px;
`;

const SectionIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: #F3EAFF;
    flex-shrink: 0;
    margin-top: 2px;
`;

const HeaderContent = styled.div`
    flex: 1;
`;

const CounterRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
`;

const Counter = styled.span`
    font-size: 12px;
    font-weight: 700;
    padding: 2px 10px;
    border-radius: 12px;
    white-space: nowrap;
    background: ${({ reached }) => reached ? '#F3EAFF' : colors.neutralDark};
    color: ${({ reached }) => reached ? colors.occasionalPurple : colors.night};
    transition: all .2s ease;
`;

const ChipsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
`;

const Chip = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 8px 16px;
    border-radius: 20px;
    font-size: 13px;
    cursor: pointer;
    user-select: none;
    transition: all .2s ease;
    border: 1.5px solid ${({ selected }) => selected ? colors.occasionalPurple : colors.nightLight};
    background: ${({ selected }) => selected ? colors.occasionalPurple : 'transparent'};
    color: ${({ selected }) => selected ? colors.neutralLight : colors.nightDark};
    opacity: ${({ disabled }) => disabled ? 0.45 : 1};
    pointer-events: ${({ disabled }) => disabled ? 'none' : 'auto'};

    ${({ shake }) => shake && `
        animation: shake 0.4s ease;
        pointer-events: auto;
        opacity: 0.6;
    `}

    &:hover {
        border-color: ${({ selected }) => selected ? colors.occasionalPurple : colors.night};
        ${({ selected }) => !selected && `background: ${colors.neutralBackground};`}
    }

    @keyframes shake {
        0%, 100% { transform: translateX(0); }
        20%, 60% { transform: translateX(-3px); }
        40%, 80% { transform: translateX(3px); }
    }

    @media screen and (min-width: ${breakpoints.lg}) {
        padding: 8px 20px;
    }
`;

const ChipLabel = styled.span`
    white-space: nowrap;
    font-weight: 600;
`;

const ErrorText = styled.p`
    color: ${colors.danger};
    font-size: 12px;
    margin-top: 10px;
    padding-left: 2px;
`;
